const BREAKPOINT_MOBILE = 769;
export const isMobile = (width) => width < BREAKPOINT_MOBILE;
